module.exports = __webpack_public_path__ + "media/images/map_icons/Bowling-38ed157b39e79b6a456fed6a7f2e8456.svg";